import "./SearchPage.scss";
import { SeparatorGrey } from "../../components/styled-components";
import PaginationComponent from "../../components/PaginationComponent/PaginationComponent";
import { Link } from "react-router-dom";
import { routesMap } from "../../routes";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../utils/Constans";
import waferssServices from "../../hooks/waferssServices";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

/**
 * @function SearchPage page rendering the results given by Header's search bar
 * @returns {JSX.Element}
*/
const SearchPage = () => {

    const { state } = useLocation();
    const { keyword, page } = state;
  
    const navigate = useNavigate();
    const { getArticoloByTesto } = waferssServices();

    const { data: results } = useQuery(['testo', keyword, page], () => getArticoloByTesto({ testo: keyword, page: page }),{
        enabled:!!(keyword),
        refetchOnWindowFocus: false 
    });

    const paginate = (pageNumber) => {
        navigate(routesMap.SEARCH_PAGE, { state: { keyword: keyword, page: pageNumber - 1 } });
    }

    return (
        <div className="SearchPage">
            <span className="SearchPage__results--searchText">{ state?.keyword }</span>
            <Helmet>
                <title>{ `${APP_NAME} | ${ results?.data?.totalElements } risultati trovati ${ results?.data?.size } per pagina` }</title>
            </Helmet>
            <span className="SearchPage__results">: { results?.data?.totalElements } risultati trovati ({results?.data?.size} per pagina)</span>
            {
                results?.data?.contenuti.map(item => {
                    const { id, title, content, idContenuto } = item;
                    return (
                        <div key={ id }>
                            { idContenuto ?
                                <Link className="SearchPage__title--link"
                                    to={ `${routesMap.DETAGLIO_CATEGORIA}/${idContenuto}`}
                                    rel={ `rel${ title }` }
                                    type="button" tabIndex="-1" role="link"
                                    dangerouslySetInnerHTML={{__html: title}}
                                >
                                </Link>
                                :
                                <span className="SearchPage__title" dangerouslySetInnerHTML={{__html: title}}></span>
                            }
                            <div className="SearchPage__content" dangerouslySetInnerHTML={{__html: content}}></div>
                            <SeparatorGrey />
                        </div>
                    );
                })
            }
            <PaginationComponent
                currentPage={ results?.data?.page + 1 }
                totalPages={ results?.data?.totalPage }
                paginate = { paginate }
            />
        </div>

    );
};

export default SearchPage;